import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var FireBurner = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7 7.9-9.9 16.8-20.7 26.5-29.5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82 0 49 36 78 81 78 18 0 34-5 49-15zM32 288c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32s-14.3 32-32 32v64h448v-64c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32v-96zm288 192c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-32c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm-288 32c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
  }));
});
FireBurner.displayName = 'FireBurner';
export var FireBurnerDimensions = {
  height: 512,
  width: 640
};